"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("li{&+li{margin-top:8px;}button{width:100%;color:", theme.color.monochrome.black, ";font-size:", theme.fontSize.large, ";letter-spacing:0;line-height:1.714;justify-content:flex-start;box-shadow:0 1px 4px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.05);text-align:left;&:hover{border-color:", theme.color.buttonPrimary.borderHover, ";}&:active{border-color:", theme.color.buttonPrimary.borderPressed, ";}svg{color:", theme.color.monochrome.dark, ";&+span{margin-left:", (0, _util.rem)(11), ";}}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var big = function big(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";li{button{border-radius:", (0, _util.rem)(12), ";padding:", (0, _util.rem)(11), " ", (0, _util.rem)(12), " ", (0, _util.rem)(12), " ", (0, _util.rem)(16), ";&>svg{width:", (0, _util.rem)(40), ";height:", (0, _util.rem)(40), ";color:", theme.color.monochrome.mediumDark, ";&+span{margin-left:", (0, _util.rem)(8), ";}}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var styles = {
  small: small,
  big: big
};
exports.styles = styles;
//# sourceMappingURL=ButtonList.styles.js.map